// 在main.js上通过import引入Vue库和自己写的Vue组件库
import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css'
import element from './element/index'

Vue.use(element)


import NodeRender from './components/NodeRender.vue';
import eventBus from "../../../../../../util/eventBus";
import {utils} from "./common/common";
import nodeDataJson from "./common/nodeData.json"

(function (KDApi) {
    function MyComponent(model) {
        this._setModel(model)
    }

    MyComponent.prototype = {
        _setModel: function (model) {
            this.model = model
        },
        init: function (props) {
            console.log('-----init', this.model.style, props)
            setHtml(this.model, props)
        },
        update: function (props) {
            eventBus.pub(this.model, 'update', props)
        },
        destoryed: function () {
            console.log('-----destoryed', this.model)
        }
    }

    const setHtml = (model, props) => {
        KDApi.loadFile(['./css/index.css','./lang/zh_CN.json','./lang/en_US.json','./lang/zh_TW.json'], model, () => {
            const {invoke, dom} = model
            Vue.prototype.model = model;
            Vue.prototype.getLangMsg = (key, configObj) => {
                return KDApi.getLangMsg(model, key, configObj)
            }
            // Vue.prototype.invoke = (eventName, args) => {
            //     invoke(eventName, args)
            // }
            Vue.prototype.eventBus = eventBus;
            Vue.prototype.nodeConfigsMap = utils.getNodeConfigs();
            new Vue({
                el: model.dom,
                template: '<NodeRender :invoke="model.invoke" :nodeData="cusParam_nodeData" :pageId="cusParam_pageId" :appRemRegId="appRemRegId" :styleConfig="styleConfig"/>',
                components: {
                    NodeRender
                },
                data: {
                    cusParam_nodeData: null,
                    cusParam_pageId:'',
                    appRemRegId:'',
                    styleConfig: {
                        content_max_w:70,
                        box_w:88,
                        box_h:40,
                        line_w:15,
                        line_h:22,
                        scale:0
                    }
                },
                beforeCreate() {
                },
                destoryed() {
                    console.log('Vue destory ')
                    eventBus.unsub(this.subUpdate)
                },
                mounted() {
                    // this.cusParam_nodeData = nodeDataJson;
                    //初始化控件配置信息
                    if (props.configItems) {
                        for (let x in props.configItems) {
                            this.styleConfig[props.configItems[x].key] = props.configItems[x].value;
                        }
                    }
                    if (props.themeNum) {
                        this.themeNum = props.themeNum;
                    }
                    if (props.lang) {
                        this.lang = props.lang;
                    }
                    if (props.data) {
                        this.getCusParam(props, "cusParam_nodeData");
                        this.getCusParam(props, "cusParam_pageId");
                        this.appRemRegId = props.data["appRemRegId"];
                    }
                    this.subUpdate = eventBus.sub(model, 'update', (props) => {
                        if (props.themeNum) {
                            this.themeNum = props.themeNum;
                        }
                        if (!props.data) {
                            return
                        }
                        this.getCusParam(props, "cusParam_nodeData");
                        this.getCusParam(props, "cusParam_pageId");
                        this.appRemRegId = props.data["appRemRegId"];
                    })
                },
                methods: {
                    getCusParam(props, key) {
                        if (props.data.hasOwnProperty(key) && props.data[key]) {
                            this[key] = props.data[key] ? JSON.parse(props.data[key]) : null;
                        }
                    }
                }
            })
        })
    }

    // 注册自定义组件
    KDApi.register('soenoderender', MyComponent, {
        isMulLang: true
    })
})(window.KDApi)
